import React, { useMemo, useContext, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Card, TextStyle, Button } from '@superops/ui-design-system';
import { AccessControl } from '@nile/components';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';

const LinkedItemsList = ({
  roles,
  module,
  workItems,
  headerLabelId,
  emptyLabelId,
  disabledItem
}) => {
  const ticketContext = useContext(TicketContext);

  const associatedItems = useMemo(() => {
    return workItems?.filter((item) => item.module === module) || [];
  }, [workItems, module]);

  const handleItemClick = (item) => {
    ticketContext.openTab({
      module: item.module === 'PROJECT' ? 'PROJECT_DETAIL' : item.module,
      data: {
        [`${item.module.toLowerCase()}Id`]: item.workId
      }
    });
  };

  const renderContent = () => (
    <>
      <TextStyle weight="Bold">
        <FormattedMessage id={headerLabelId} />
      </TextStyle>
      {associatedItems?.length > 0
        ? associatedItems.map((item) => {
            return (
              <Button
                plain
                textAlign="left"
                onClick={() => handleItemClick(item)}
                disabled={disabledItem}
              >
                {item.subject}
              </Button>
            );
          })
        : emptyLabelId && (
            <TextStyle variation="subdued">
              <FormattedMessage id={emptyLabelId} />
            </TextStyle>
          )}
    </>
  );

  return (
    <AccessControl
      roleToCheck={{ roles: roles || [] }}
      render={
        <Card customClassName="full-width">
          <div className="fx col tw-gap-3 tw-p-4">{renderContent()}</div>
        </Card>
      }
    />
  );
};

export default LinkedItemsList;
